import Sticky from './sticky.js';

window.addEventListener('load', function () {
	scrollToActiveSidenavItem();
	addAccessibleAriaLabels('click');
});

// add correct aria labels for when subnav categories are expanded/not expanded
const addAccessibleAriaLabels = function (event) {
	let navCategories = document.getElementsByClassName('platform-sidenav__collectionLabel');

	Array.prototype.forEach.call(navCategories, function (element) {
		element.addEventListener(event, function () {
			event.preventDefault ? event.preventDefault() : (event.returnValue = false);
			let subNav = findElementSubNav(element);
			let navCategoryParent = element.parentNode;

			navCategoryParent.classList.toggle('is-closed');

			if (navCategoryParent.classList.contains('is-closed')) {
				element.setAttribute('aria-expanded', 'false');
				subNav[0].setAttribute('aria-expanded', 'false');
				subNav[0].setAttribute('aria-hidden', 'true');
			} else {
				element.setAttribute('aria-expanded', 'true');
				subNav[0].setAttribute('aria-expanded', 'true');
				subNav[0].setAttribute('aria-hidden', 'false');
				subNav[0].firstElementChild.focus();
			}
		});
	});
};

// helper function to find subnavs in single nav list item
const findElementSubNav = function (elem) {
	// Setup siblings array and get the first sibling
	let siblings = [];
	let sibling = elem.parentNode.firstChild;

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}

	return siblings;
};


//to enable the sticky!
sticky = new Sticky('[data-sticky]');

// Animate mobile navigation banner above content on scroll
function sticky_relocate(windowTop) {
	const divTop = document.querySelector('#content-anchor').offsetTop;
	if (windowTop > divTop) {
		document.querySelector('.ontario-header-navigation__banner').classList.add('stick');
	} else {
		document.querySelector('.ontario-header-navigation__banner').classList.remove('stick');
	}
}

// const menuScrollElement = document.querySelector('.ontario-header-navigation__menu-list');

// menuScrollElement.addEventListener('scroll', event => {
// 	const windowTop = menuScrollElement.scrollTop;
// 	sticky_relocate(windowTop);
// });

/**
 * This function scrolls the active sidenav item into view
 * and then resets the window view back to the top.
 */
function scrollToActiveSidenavItem() {
	let activeItem = document.querySelector('[data-state="current"]');
	(activeItem);
	if (activeItem) {
		activeItem.scrollIntoView({ block: 'center' });
		// Bring the header back in to view
		window.scrollTo(0, 0);
	}
}
